import * as React from 'react';
import { Base64 } from 'js-base64';
import { TAdFoxBannerTemplate } from '@cian/adfox-component';
import {
  ITgbPrimaryTemplateParams,
  TgbPrimary,
  MobileTgb,
  IMobileTgbParams,
} from '../../../../../components/NewAdfoxTemplates';
import { useApplicationContext } from '../../../../../utils/applicationContext';

const OWN_BUNDLE_NAMES = ['banner.transfer'];
const OWN_TYPES = ['tgb_primary', 'tgb'];

interface IUnknownTemplate {
  type: string;
}

export type TAdFoxTemplatesParams = ITgbPrimaryTemplateParams | IMobileTgbParams;

export const OwnTemplatesContainer: React.FC<TAdFoxBannerTemplate> = props => {
  const { logger } = useApplicationContext();
  const { bundleName, bundleParams, containerId } = props;

  if (bundleName && OWN_BUNDLE_NAMES.includes(bundleName) && bundleParams) {
    if (bundleName === 'banner.transfer' && bundleParams.htmlBase64) {
      try {
        const decodedParams = Base64.decode(bundleParams.htmlBase64);
        const parsedDecodedParams: TAdFoxTemplatesParams = JSON.parse(decodedParams);

        if (isParsedParamsValid(parsedDecodedParams) && OWN_TYPES.includes(parsedDecodedParams.type)) {
          switch (parsedDecodedParams.type) {
            case 'tgb_primary':
              return <TgbPrimary {...parsedDecodedParams} />;

            case 'tgb':
              return <MobileTgb {...parsedDecodedParams} />;

            default:
              console.warn(
                '[AdFox] Known type is not found',
                (parsedDecodedParams as IUnknownTemplate).type,
                bundleParams,
              );
          }
        }
      } catch (e) {
        logger.error(e, {
          message: '[AdFox] Failed to decode/parse bundleParams',
          bannerId: props.bundleParams?.bannerId,
        });
      }
    }
  }

  return <div data-testid={'OwnTemplatesContainer'} id={containerId} />;
};

function isParsedParamsValid(params: object): params is TAdFoxTemplatesParams {
  return 'type' in params;
}
